import React from 'react';
import PropTypes from 'prop-types';

import { breakpoints } from '../../edlio-js/constants';

/**
 * DeviceTracker is intended to help keep track of which "device" category the
 * user's width viewport falls under.
 */
export default class DeviceTracker extends React.Component {
  constructor(props) {
    super(props);

    this.handleWindowResize = this.handleWindowResize.bind(this);
  }

  componentDidMount() {
    this.handleWindowResize();
    window.addEventListener('resize', this.handleWindowResize, false);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowResize, false);
  }

  handleWindowResize() {
    const { onResize } = this.props;

    const { mobile, tablet } = breakpoints;

    if (window.innerWidth < mobile) {
      onResize('mobile');
    } else if (window.innerWidth < tablet && window.innerWidth >= mobile) {
      onResize('tablet');
    } else if (window.innerWidth >= tablet) {
      onResize('desktop');
    }
  }

  render() {
    return <div style={{ display: 'none' }} />
  }
}

DeviceTracker.propTypes = {
  onResize: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/main/webapps/common/react/components/device-tracker.js